import { isLoggedInAtom } from "@/modules/api/apikey.store.ts";
import LoginsRoot from "@/modules/login/LoginsRoot.tsx";
import { createFileRoute } from "@tanstack/react-router";
import { useAtomValue } from "jotai/react";
import React from "react";

// NB: Import this lazily so it is not loaded for the initial login page / the root bundle
const MainRoot = React.lazy(() => import("@/modules/main/MainRoot.tsx"));

export const Route = createFileRoute("/_main")({
    component: MainRoutes,
});

function MainRoutes() {
    const loggedIn = useAtomValue(isLoggedInAtom);
    if (!loggedIn) {
        return <LoginsRoot />;
    }

    return <MainRoot />;
}
